import Vue from 'vue'
import Router from 'vue-router'

import AtendimentosNoMesRoutes from './routes/AtendimentosNoMes'
import UltimasVisualizacoesRoutes from './routes/UltimasVisualizacoes'
import EnvioAppRoutes from './routes/EnvioApp'
import GestaoCadastrosRoutes from './routes/GestaoCadastros'
import InformatizaApsRoutes from './routes/InformatizaAps'
import Iaf from './routes/Iaf'
import Pse from './routes/Pse'
import IndicadoresApsRoutes from './routes/IndicadoresAps'
import ProfissionaisPecCnesRoutes from './routes/ProfissionaisPecCnes'
import AdministracaoRoutes from './routes/Administracao'
import Imunizacao from './routes/Imunizacao'
import VisitasDomiciliaresRoutes from './routes/VisitasDomiciliares'
import SaudeCriancaRoutes from './routes/SaudeCrianca'
import RiscoCardiovascularRoutes from './routes/RiscoCardiovascular'
import ProducaoRoutes from './routes/Producao'
import AedesAegypti from './routes/AedesAegypti'
import PosCovid19 from './routes/PosCovid19'
import ExportarDados from './routes/ExportarDados'
import VinculoAcompanhamento from './routes/VinculoAcompanhamento'
import BpaERas from './routes/BpaERas'
import Tria from './routes/Tria'
import SaudeBucalRoutes from './routes/SaudeBucal'
import eSfeAPRoutes from './routes/eSFeAP'
import eMultiRoutes from './routes/eMulti'
import OficinasTreinamentosRoutes from './routes/OficinasTreinamentos'
import UpaRoutes from './routes/Upa'
import DocumentacaoRoutes from './routes/Documentacao'
import store from '@/store/store.js'
import { permissoes } from '@/services/Permissoes.js'
import { jwtDecode } from 'jwt-decode'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: () => import('./layouts/Login/index.vue'),
      meta: {
        public: true,
      },
      children: [
        {
          path: '/',
          component: () => import('./pages/Index.vue'),
        },
        {
          path: '/nosso-dia-a-dia',
          component: () => import('./pages/NossoDiaDia/Index.vue'),
        },
        {
          path: '/termos-de-uso',
          component: () => import('./pages/Termos.vue'),
        },
        {
          path: '/recursos',
          component: () => import('./pages/Recursos.vue'),
        },
        {
          path: '/uso-cientifico',
          component: () => import('@/pages/UsoCientifico/Index.vue'),
        },
        {
          path: '/avaliacoes',
          component: () => import('./pages/Avaliacoes.vue'),
        },
        {
          path: '/cofinanciamento/mapa-ied',
          component: () =>
            import('./pages/Cofinanciamento/MapaIed/MapaIed.vue'),
        },
        {
          path: '/previne-brasil/regional',
          component: () => import('./pages/PrevineBrasil/Regional.vue'),
        },
        {
          path: '/previne-brasil/municipios-na-meta',
          component: () => import('./pages/PrevineBrasil/MunicipiosNaMeta.vue'),
        },
        {
          path: '/previne-brasil/mapa-desempenho',
          component: () => import('./pages/PrevineBrasil/MapaDesempenho.vue'),
        },
        {
          path: '/previne-brasil/lista',
          component: () => import('./pages/PrevineBrasil/Lista.vue'),
        },
        {
          path: '/previne-brasil/estados',
          component: () => import('./pages/PrevineBrasil/Estados.vue'),
        },
        {
          path: '/cofinanciamento/ranking-geral',
          component: () =>
            import('./pages/Cofinanciamento/RankingGeral/Index.vue'),
        },
        {
          path: '/cofinanciamento/ranking-regional',
          component: () =>
            import('./pages/Cofinanciamento/RankingRegional/Index.vue'),
        },
        {
          path: '/cofinanciamento/ranking-porte-populacional',
          component: () =>
            import(
              './pages/Cofinanciamento/RankingPortePopulacional/Index.vue'
            ),
        },
      ],
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('./pages/Auth/Login.vue'),
      meta: {
        public: true,
      },
    },
    {
      path: '/login/:identificador_publico',
      name: 'loginPec',
      component: () => import('./pages/Pec/Login/Index.vue'),
      meta: {
        public: true,
      },
    },
    {
      path: '/pep/:identificador_publico',
      name: 'pep-auth',
      component: () => import('./pages/Pep/Auth.vue'),
      meta: {
        public: true,
      },
    },
    {
      path: '/pep/:identificador_publico/atendimento-360',
      name: 'pep-atendimento-360',
      component: () => import('./pages/Pep/Atendimento360/Index.vue'),
      meta: {
        requiresPepAuth: true,
      },
    },
    {
      path: '/privacidade',
      component: () => import('./pages/PrivacidadeTermos/Index.vue'),
      meta: {
        public: true,
      },
    },
    {
      path: '/termos-uso',
      component: () => import('./pages/PrivacidadeTermos/Index.vue'),
      meta: {
        public: true,
      },
    },
    {
      path: '/cofinanciamento/simulacao',
      component: () => import('./pages/CofinanciamentoSimulacao/Index.vue'),
      meta: {
        public: true,
      },
    },
    {
      path: '/demonstracao',
      component: () => import('./pages/Auth/Demonstracao.vue'),
      meta: {
        public: true,
      },
    },
    {
      path: '/criar-conta',
      component: () => import('./pages/Auth/CriarConta.vue'),
      meta: {
        public: true,
      },
    },
    {
      path: '/recuperar-senha',
      component: () => import('./pages/Auth/RecuperarSenha.vue'),
      meta: {
        public: true,
      },
    },
    {
      path: '/dashboard',
      component: () => import('./pages/Dashboard.vue'),
      meta: {
        skipPermissionCheck: true,
      },
    },
    {
      path: '/acesso-negado',
      component: () => import('./pages/Auth/AcessoNegado.vue'),
      meta: {
        public: true,
      },
    },
    {
      path: '/atualizar-cadastro',
      component: () => import('./pages/Auth/AtualizarCadastro.vue'),
      meta: {
        skipPermissionCheck: true,
      },
    },
    {
      path: '/municipio-negado',
      component: () => import('./pages/Auth/MunicipioNegado.vue'),
      meta: {
        public: true,
      },
    },
    {
      path: '/usuario-inativo',
      component: () => import('./pages/Auth/UsuarioInativo.vue'),
      meta: {
        public: true,
      },
    },
    {
      path: '/lotacoes/:cod_ibge/:nu_cpf',
      component: () => import('./pages/Auth/EscolherAcesso.vue'),
    },
    {
      path: '/atualizacao-cadastro',
      name: 'atualizacao-cadastro',
      component: () => import('./pages/Auth/AtualizacaoCadastro.vue'),
      meta: {
        passwordUpdateRoute: true,
      },
    },
    {
      path: '/alterar-municipio',
      component: () => import('./pages/Auth/AlterarMunicipio.vue'),
      meta: {
        skipPermissionCheck: true,
      },
    },
    {
      path: '/orcamento',
      component: () => import('./pages/Orcamento/Index'),
      meta: {
        public: true,
      },
    },
    {
      path: '/proposta',
      component: () => import('./pages/Orcamento/Proposta'),
      meta: {
        public: true,
      },
    },
    {
      path: '/chatbot/fd0066e5-3dc7-4536-a9d6-93740104a790',
      component: () => import('./pages/Chatbot/Index.vue'),
      meta: {
        public: true,
      },
    },
    {
      path: '/suporte/fd0066e5',
      component: () => import('./pages/Suporte/Index.vue'),
      meta: {
        public: true,
      },
    },
    {
      path: '/excluirdados',
      component: () => import('./pages/Auth/TutorialExcluirDados.vue'),
      meta: {
        public: true,
      },
    },
    {
      path: '/pagina-indisponivel',
      component: () => import('./pages/Auth/PaginaIndisponivel.vue'),
      meta: {
        public: true,
      },
    },
    {
      path: '/documentacao',
      component: () => import('./pages/Documentacao/Index.vue'),
      meta: {
        public: true,
      },
      children: [...DocumentacaoRoutes],
    },
    {
      path: '/previne-brasil/simulador',
      component: () => import('./pages/PrevineBrasil/Simulador/index.vue'),
      meta: {
        public: true,
      },
    },
    {
      path: '/avaliacao-treinamento',
      component: () => import('./pages/AvaliacaoTreinamento/Index.vue'),
      meta: {
        public: true,
      },
    },
    {
      path: '/guia-codigos-indicadores',
      component: () => import('./pages/GuiaCodigosIndicadores/Index.vue'),
      meta: {
        public: true,
      },
    },
    {
      path: '/iaf',
      component: () => import('./pages/Iaf/Index.vue'),
    },
    {
      path: '/cofinanciamento/mapa-ubs',
      component: () => import('./pages/Cofinanciamento/MapaUbs/MapaUbs.vue'),
      meta: {
        public: true,
      },
    },
    {
      path: '/pse',
      component: () => import('./pages/Pse/Index.vue'),
    },
    {
      path: '/oficina-monitoramento-avaliacao',
      component: () =>
        import('./pages/OficinaMonitoramenteAvaliacao/index.vue'),
    },
    {
      path: '/oficina-monitoramento-avaliacao/apresentacao',
      component: () =>
        import('./pages/OficinaMonitoramenteAvaliacao/index.vue'),
    },
    {
      path: '/atendimentos-pessoa',
      component: () => import('@/pages/AtendimentosPessoa/Index.vue'),
    },
    {
      path: '/cidadaos-cns-invalidos',
      component: () =>
        import('@/pages/GestaoCadastros/CidadaosCnsInvalidos/Index.vue'),
    },
    {
      path: '/cidadaos-desatualizados',
      component: () =>
        import('@/pages/GestaoCadastros/CidadaosDesatualizados/Index.vue'),
    },
    {
      path: '/oficinas-treinamentos/validar-certificado',
      name: 'validar-certificado',
      component: () =>
        import('@/pages/AtividadeColetiva/ValidarCertificado.vue'),
      meta: {
        public: true,
      },
    },
    {
      path: '/oficinas-treinamentos/validar-certificado/:codigo',
      name: 'validar-certificado-codigo',
      component: () =>
        import('@/pages/AtividadeColetiva/ValidarCertificado.vue'),
      meta: {
        public: true,
      },
    },
    ...AtendimentosNoMesRoutes,
    ...UltimasVisualizacoesRoutes,
    ...EnvioAppRoutes,
    ...GestaoCadastrosRoutes,
    ...InformatizaApsRoutes,
    ...Iaf,
    ...Pse,
    ...IndicadoresApsRoutes,
    ...ProfissionaisPecCnesRoutes,
    ...AdministracaoRoutes,
    ...Imunizacao,
    ...VisitasDomiciliaresRoutes,
    ...SaudeCriancaRoutes,
    ...RiscoCardiovascularRoutes,
    ...ProducaoRoutes,
    ...AedesAegypti,
    ...PosCovid19,
    ...ExportarDados,
    ...VinculoAcompanhamento,
    ...BpaERas,
    ...Tria,
    ...SaudeBucalRoutes,
    ...eSfeAPRoutes,
    ...eMultiRoutes,
    ...OficinasTreinamentosRoutes,
    ...UpaRoutes,
    {
      path: '*',
      redirect: '/',
    },
  ],
})

/**
 * Valida a autenticação necessária para acessar uma rota privada do PEP.
 *
 * @param {Object} to Rota que está sendo acessada.
 * @param {Function} next Função responsável por concluir ou redirecionar a navegação.
 * @returns {void}
 */
async function validarPep(to, next) {
  const identificadorPublicoRota = String(
    to.params.identificador_publico || ''
  ).trim()

  const autenticado = store.getters['pep/autenticado']
  const tokenPep = store.getters['pep/token']
  const identificadorPublicoAutenticado =
    store.getters['pep/identificadorPublico']

  const redirecionarParaAutenticacao = async () => {
    await store.dispatch('pep/logout')

    next({
      name: 'pep-auth',
      params: {
        identificador_publico: identificadorPublicoRota,
      },
    })
  }

  if (!identificadorPublicoRota) {
    await redirecionarParaAutenticacao()
    return
  }

  if (!autenticado || !tokenPep) {
    await redirecionarParaAutenticacao()
    return
  }

  if (String(identificadorPublicoAutenticado) !== identificadorPublicoRota) {
    await redirecionarParaAutenticacao()
    return
  }

  try {
    const tokenDecodificado = jwtDecode(tokenPep)
    const agoraEmSegundos = Math.floor(Date.now() / 1000)

    if (!tokenDecodificado.exp || tokenDecodificado.exp <= agoraEmSegundos) {
      await redirecionarParaAutenticacao()
      return
    }
  } catch (error) {
    console.error('Token de autenticação do PEP inválido:', error)

    await redirecionarParaAutenticacao()
    return
  }

  next()
}

router.beforeEach((to, from, next) => {
  const isPublicRoute = to.matched.some((route) => route.meta.public)

  const requiresPepAuth = to.matched.some((route) => route.meta.requiresPepAuth)

  const isPasswordUpdateRoute = to.matched.some(
    (route) => route.meta.passwordUpdateRoute
  )

  const skipPermissionCheck = to.matched.some(
    (route) => route.meta.skipPermissionCheck
  )

  // Rotas públicas.
  if (isPublicRoute) {
    next()
    return
  }

  // Rotas privadas do contexto PEP.
  if (requiresPepAuth) {
    validarPep(to, next)
    return
  }

  // Todas as rotas abaixo exigem autenticação normal.
  if (!store.getters.getAccessToken) {
    store.dispatch('logout')
    next({ name: 'login' })
    return
  }

  const precisaAtualizarCadastro = store.getters.getRequiredPasswordUpdate

  /*
   * Enquanto a atualização estiver pendente,
   * bloqueia qualquer outra rota privada.
   */
  if (precisaAtualizarCadastro && !isPasswordUpdateRoute) {
    next({ name: 'atualizacao-cadastro' })
    return
  }

  /*
   * A atualização cadastral exige autenticação,
   * mas não passa pela lista comum de permissões.
   */
  if (isPasswordUpdateRoute) {
    next()
    return
  }

  /*
   * Rotas que exigem autenticação,
   * mas não utilizam a matriz comum de permissões.
   */
  if (skipPermissionCheck) {
    next()
    return
  }

  // A página de lotações só é permitida para Médico, enfermeiro, odontólogo, téc. saúde bucal, emulti, recepcionista
  if (to.path.includes('/lotacoes')) {
    if (
      store.getters.getIdFuncao == 4 ||
      store.getters.getIdFuncao == 5 ||
      store.getters.getIdFuncao == 8 ||
      store.getters.getIdFuncao == 14 ||
      store.getters.getIdFuncao == 15
    ) {
      next()
      return
    } else {
      store.dispatch('logout')
      next('/login')
      return
    }
  }

  // verificação das rotas
  const token = store.state.accessToken
  const decoded = jwtDecode(token)
  const permissoesToken = store.state.permissoesRaw ?? null

  if (!permissoesToken) {
    store.dispatch('logout')
    next('/login')
    return
  }

  const perfil = permissoes.find((item) => {
    return (
      item.id_perfil == Number(store.state.id_funcao) &&
      item.nome == decoded.funcao
    )
  })

  if (!perfil) {
    store.dispatch('logout')
    next('/login')
    return
  }

  let authorization = false
  if (
    decoded.cod_ibge == Number(store.state.cod_ibge) &&
    decoded.id_funcao == Number(store.state.id_funcao) &&
    (decoded.funcao == perfil.nome || perfil.nome.includes(decoded.funcao))
  ) {
    for (const key in perfil) {
      if (key !== 'nome' && key !== 'id_perfil') {
        for (let index = 0; index < perfil[key].length; index++) {
          const element = perfil[key][index]
          const entryPermissionToken = Object.entries(permissoesToken).find(
            ([key, value]) => {
              return key === element.key
            }
          )
          if (element.link == to.path) {
            if (entryPermissionToken) {
              const [keyPermissionToken, valuePermissionToken] =
                entryPermissionToken
              if (valuePermissionToken == 1) {
                authorization = true
              }
            }
          }
        }
      }
    }
  }

  if (!authorization) {
    store.dispatch('logout')
    next('/login')
  } else {
    next()
  }
})

export default router
